export default __webpack_public_path__ + "static/media/000_Korn_Better_Life_1_Sample.c5e312aa.mp3";